import { z } from "zod";
export const RESEARCH_WAREHOUSE_PROFILE = "beaver_research";
export const MESHSQL_SURFACE_PROFILE = "meshsql_surface";
export const MESHSQL_SURFACE_DATABASE_ROLE = "mlx_lvf_meshsql_reader";
export const researchWarehouseProfileSchema = z.enum([
    RESEARCH_WAREHOUSE_PROFILE,
    MESHSQL_SURFACE_PROFILE,
]);
export function researchWarehouseSelectionEnabled(env) {
    return env.MLX_RESEARCH_WAREHOUSE_ENABLED?.trim().toLowerCase() === "true";
}
export function meshsqlSurfaceSelectionEnabled(env) {
    return env.MLX_MESHSQL_SURFACE_ENABLED?.trim().toLowerCase() === "true";
}
export function researchWarehouseFeatureConfig(env) {
    const enabled = env.MLX_RESEARCH_WAREHOUSE_ENABLED?.trim().toLowerCase();
    if (!enabled || enabled === "false")
        return { status: "disabled" };
    if (enabled !== "true") {
        return { status: "misconfigured", reason: "enabled must be true or false" };
    }
    const connectionString = env.MLX_RESEARCH_WAREHOUSE_DATABASE_URL?.trim();
    if (!connectionString) {
        return {
            status: "misconfigured",
            reason: "enabled requires a research warehouse database URL",
        };
    }
    const allowedSchemas = (env.MLX_RESEARCH_WAREHOUSE_ALLOWED_SCHEMAS ?? "")
        .split(",")
        .map((value) => value.trim())
        .filter(Boolean);
    if (allowedSchemas.length === 0) {
        return {
            status: "misconfigured",
            reason: "enabled requires at least one allowed schema",
        };
    }
    return {
        status: "enabled",
        profile: RESEARCH_WAREHOUSE_PROFILE,
        connectionString,
        allowedSchemas,
    };
}
export function meshsqlSurfaceFeatureConfig(env) {
    const enabled = env.MLX_MESHSQL_SURFACE_ENABLED?.trim().toLowerCase();
    if (!enabled || enabled === "false")
        return { status: "disabled" };
    if (enabled !== "true") {
        return { status: "misconfigured", reason: "enabled must be true or false" };
    }
    const allowedSchemas = (env.MLX_MESHSQL_SURFACE_ALLOWED_SCHEMAS ?? "")
        .split(",").map((value) => value.trim()).filter(Boolean);
    const databaseRole = env.MLX_MESHSQL_SURFACE_DATABASE_ROLE?.trim();
    if (allowedSchemas.length !== 1 || allowedSchemas[0] !== "meshsql_surface" ||
        databaseRole !== MESHSQL_SURFACE_DATABASE_ROLE) {
        return { status: "misconfigured",
            reason: "enabled requires the sealed MeshSQL schema and database role" };
    }
    return { status: "enabled", profile: MESHSQL_SURFACE_PROFILE,
        connectionString: "", allowedSchemas };
}
export function warehouseProfileFeatureConfig(env, profile) {
    return profile === MESHSQL_SURFACE_PROFILE
        ? meshsqlSurfaceFeatureConfig(env)
        : researchWarehouseFeatureConfig(env);
}
